/****************************************************************
Alexander Self
8/23/17
Team list:Displyas a list of gangs
****************************************************************/
import React from 'react';
import { FloatingButton } from './inputs';
const $ = window.$;
const GeneralGangList = ({ gangs, onClick, id }) => {
  return (
    <ul className="collection" id={id}>
      {
        gangs.map((g) => {
          $(document).ready(() => {
            $(`#${g.gangId}`).collapsible();
          });
          if (g.status) {
            return (
              <li key={g.gangId} className="collection-item">
                <div className="row">
                  Team: <b>{ g.gangId }</b><hr />
                  Count: <b>{ g.gangCount }</b><br />
                  Location: <b>{ g.gangLoc === 72 ? `Kea'au` : `Ka'u` }</b><br />
                  <button className={`btn-floating waves-effect waves-light grey`} onClick={() => onClick(g)}>
                    <i className="material-icons">person_add</i>
                  </button>
                </div>
              </li>
            )
          }
          return (
            <li key={g.gangId} className="collection-item">
              <div className="row">
                Team: <b>{ g.gangId }</b><hr />
                Count: <b>{ g.gangCount }</b><br />
                Location: <b>{ g.gangLoc === 72 ? `Kea'au` : `Ka'u` }</b><br />
                <FloatingButton color={'green'} icon={'person_add'} onclick={() => onClick(g)}  />
                <details>
                  <summary>Employees</summary>
                  <ul>
                    {
                      g.emps.map((e) => (
                        <li key={Math.random()} className="gang-employees"><span className="gang-employees-font">
                          {e.firstName === null ? '' : e.firstName} {e.lastName === null ? '' : e.lastName}</span>
                        </li>
                      ))
                    }
                  </ul>
                </details>
              </div>
            </li>
          )
        })
      }
    </ul>
  );
};

export default GeneralGangList;



// WEBPACK FOOTER //
// ./src/components/general_gang_list.js